var _style, _path, _foreignObject, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcdsLoading2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "acds-loading",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t#acds-loading {\n\t\ttransform-origin: center;\n\t\twidth: 100px;\n\t\theight: 100px;\n\t\tmargin: 0 auto;\n\t\tmargin-top: 25vh;\n\t\t-webkit-animation: scale 2s;\n\t\tanimation: scale 2s;\n\t\t-webkit-transform: scale(0,0); \n\t\ttransform: scale(0,0);\n\t\t-webkit-animation-fill-mode: forwards;\n\t\tanimation-fill-mode: forwards;\n\t\tbackground: #fff;\n\t\t}\n\t\n\n\t@-webkit-keyframes scale {\n\t\t100% {\n\t\t\t-webkit-transform: scale(1,1); \n\t\t}\n\t}\n\n\t@keyframes scale {\n\t\t100% {\n\t\t\ttransform: scale(1,1); \n\t\t}\n\t}\n\t.acds-a {\n\t\tfill:#00A59B;\n\t\t}\n\t.border {\n\t\tfill:#6EC3C1;\n\t\t}\n\tdiv.sweep {\n\t\twidth: 100px; height: 100px;\n\t\tborder-radius: 50%;\n\t\tbackground-image: conic-gradient(rgba(255,255,255,1) 20%,rgba(255,255,255,0) 80%);\n\t\t}\n")), /*#__PURE__*/React.createElement("svg", _extends({
    y: 2.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "acds-a",
    d: "M62,59l9.7-2.1l7.1,19.3h-11L62,59z M38.7,49.8c-3.9,0.8-7.5,2.7-10.3,5.5l17.2-47h8.3L67.3,45l-9.6,1.6 L50,23.6l-9,25.7L38.7,49.8z M31.7,76.1h-11l4.9-13C27.8,57.3,32.9,53,39,51.8l39.7-6.7L75,51.9c-0.8,1.5-2.3,2.6-4,2.9l-0.1,0 l-24.7,5.4C40.1,61.6,35.2,66,33.1,72L31.7,76.1z"
  })), _foreignObject || (_foreignObject = /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, /*#__PURE__*/React.createElement("div", {
    className: "sweep",
    xmlns: "http://www.w3.org/1999/xhtml"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "3s",
    from: "0 50 50",
    to: "360 50 50",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    y: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "border",
    d: "M50,99.3C22.8,99.3,0.7,77.2,0.7,50C0.7,22.8,22.8,0.7,50,0.7c27.2,0,49.3,22.1,49.3,49.3 c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3c0-25.8-21-46.7-46.7-46.7C24.2,3.3,3.3,24.2,3.3,50c0,25.8,21,46.7,46.7,46.7 c0.7,0,1.3,0.6,1.3,1.3S50.7,99.3,50,99.3z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "2s",
    from: "-0 50 50",
    to: "-360 50 50",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcdsLoading2);
export default __webpack_public_path__ + "static/media/acds-loading2.95decafdbfb443cd673ada7b193cb012.svg";
export { ForwardRef as ReactComponent };